import {parseUserAgent} from "react-device-detect";
import {getLanguage} from "../i18n";
import packageJson from "../../../package.json";

const getDefaultHeaders = () => {
	const userAgent = parseUserAgent(window.navigator.userAgent);
	const { browser, os } = userAgent;
	return {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'Accept-Language': getLanguage(),
		'x-app-user-agent': `${browser?.name} ${browser?.version}`,
		'x-app-system': `${os?.name} ${os?.version}`,
		'x-app-build-version': packageJson.version,
	}
}

export default getDefaultHeaders;
